import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  SLanguage: "",
};

const SelectLanguageSlice = createSlice({
  name: "SelectLanguageSlice",
  initialState,

  reducers: {
    SelectLanguageData(state, action) {
      return {
        SLanguage: action.payload.SLanguage,
      };
    },
  },
});
export const { SelectLanguageData } = SelectLanguageSlice.actions;
export default SelectLanguageSlice.reducer;
